import React from 'react';
import { F } from '../../styles/theme';

// ── EmbossPct ───────────────────────────────────────────────────────────────
// Vermögens-Anteil als massive Ziffer mit echtem PRÄGEDRUCK (Letterpress) —
// in die Fläche gepresst, definiert allein über die Licht/Schatten-Kante.
// KEIN Punkt-/Dot-Stil (User verwarf den Pointillismus 2026-06-10).
//
// Variante „tonal / tiefer Druck" (User-Wahl): die Ziffer steht fast in der
// Flächenfarbe, erst die geprägte Kante macht sie sichtbar — bewusst leise,
// echtester Prägeeindruck. Auf `T.bg` abgestimmt (heller Lichtsaum unten +
// dunkle Gegenkante oben = Vertiefung). Kein Container-Tint → konform zu
// feedback_no_pills_borders_glow.

function press(T) {
  return T.isDark
    ? {
        // Auf Dunkel lebt die Prägung fast nur von der Lichtkante → deutlich
        // stärker (sonst unsichtbar). Ziffer minimal heller als bg als Basis,
        // helle Unterkante (Licht) + dunkle Gegenkante oben (Vertiefung).
        color: '#282C33',
        shadow: '0 1.5px 0.5px rgba(255,255,255,0.22), 0 -1px 1px rgba(0,0,0,0.9)',
      }
    : {
        // Hell = Paper-Grey (NEUTRAL), nicht mehr warmes Creme. Ziffer ein paar
        // Nuancen unter der Surface, neutrale (nicht braune) Gegenkante.
        color: '#D8D7D2',
        shadow: '0 1px 0 rgba(255,255,255,0.95), 0 -1.5px 1px rgba(0,0,0,0.20), 0 1px 2px rgba(0,0,0,0.07)',
      };
}

export default function EmbossPct({ value, T, size = 28, ariaLabel }) {
  if (value == null || Number.isNaN(value)) return null;
  const str = value < 1 ? '<1%' : `${Math.round(value)}%`;
  const p = press(T);
  return (
    <span
      role="img"
      aria-label={ariaLabel ?? str}
      style={{
        fontFamily: F.num || F.display,
        fontWeight: 700,
        fontSize: size,
        lineHeight: 1,
        letterSpacing: '-0.02em',
        fontVariantNumeric: 'tabular-nums',
        color: p.color,
        textShadow: p.shadow,
        userSelect: 'none',
        whiteSpace: 'nowrap',
      }}
    >
      {str}
    </span>
  );
}
